function FAQAccordian() {
  const faqsList = document.querySelector(".faqsList");
  if (!faqsList) return;

  faqsList.addEventListener("click", function (e) {
    const question = e.target.closest(".faqsList__question");
    if (!question) return;
    const item = question.closest(".faqsList__item");
    if (!item) return;
    const answer = item.querySelector(".faqsList__answer");
    const isActive = question.classList.contains("active");

    // Close all
    faqsList
      .querySelectorAll(".faqsList__question.active, .faqsList__answer.active")
      .forEach((el) => el.classList.remove("active"));

    // Toggle current
    if (!isActive) {
      question.classList.add("active");
      if (answer) answer.classList.add("active");
    }
  });
}

export default FAQAccordian;
